var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { config } from './config';
export var useTopicNavConfig = function () {
    var formatMessage = useIntl().formatMessage;
    return useMemo(function () {
        var topics = config.topics.map(function (topic) { return (__assign(__assign({}, topic), { label: formatMessage(topic.label) })); });
        var products = config.products.map(function (product) { return (__assign(__assign({}, product), { label: formatMessage(product.label) })); });
        return { topics: topics, products: products };
    }, [formatMessage]);
};
